import { Vue } from 'vue-property-decorator'
import { ApiResponseLogin } from '@/api/responses/login'

export namespace LoginApi {
  /**
   * ログイン
   *
   * @param uid ログインID
   * @param password パスワード
   * @param role ログイン権限
   * @returns 認証情報
   */
  export async function login(uid: string, password: string, role: string): Promise<ApiResponseLogin> {
    const params = {
      uid: uid,
      password: password,
      role: role,
    }
    const res = await Vue.prototype.$http.post('/auth/sign_in', params)
    return res.data
  }
}
